import React, { Component } from 'react';
import { Panel, Modal } from 'react-bootstrap/lib';
import Icon from 'noc/components/icon';

class TicketsTechniciansPanel extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            open: true,
            showModal: false
        };
    }


    render() {
        const { TicketPlayStatusData, TechStatusData, refreshTechnician, UserDetails } = this.props;

        return (
            <div className="ttd-panel">
                <h2 className="ttd-panel__header" role="button" tabIndex="0" aria-expanded="true">
                    
                    <a
                        href="javascript:;" onClick={() => this.setState({ open: !this.state.open })}
                        title="Expand / Collapse"
                    >
                        <Icon type="cn-icon--menu" icon={!this.state.open ? 'icon-triangle-down' : 'icon-triangle-up'} />
                        <strong>
                            TICKETS : {TechStatusData ? `${TicketPlayStatusData.TotalTickets}` : '0'}&nbsp;
                            |&nbsp; TECHNICIANS : {TechStatusData ? `${TechStatusData.Total}` : '0'}
                        </strong>
                    </a>
                    
                    <span className="ttd-panel__header-info">
                        Last Update {TechStatusData ? `${TicketPlayStatusData.RefreshTime}` : ''}
                        <a href="javascript:;">
                            <Icon
                                type="cn-icon--tool" icon="icon-refresh"
                                onClick={() => refreshTechnician()}
                            />
                        </a>
                    </span>
                </h2>
                <Panel collapsible expanded={this.state.open}>
                    <div className="ticket-technician-box">
                        <ul className="tickets-box">
                            <li>
                                <strong>TICKETS TOTAL</strong>
                                <div>{TicketPlayStatusData ? `${TicketPlayStatusData.TotalTickets}` : '(0)'}</div>
                            </li>
                            <li >
                                <strong>IN PLAY</strong>
                                <div>{TicketPlayStatusData ? `${TicketPlayStatusData.TotalInPlayTickets}` : '(0)'}</div>
                            </li>
                            <li>
                                <strong>NOT IN PLAY</strong>
                                <div>{TicketPlayStatusData ? `${TicketPlayStatusData.TotalNotInPlayTickets}` : '(0)'}</div>
                            </li>
                        </ul>
                        <ul className="technicians-box">
                            <li>
                                <strong>TECHS TOTAL</strong>
                                <div>{TechStatusData ? `${TechStatusData.Total}` : '(0)'}</div>
                            </li>
                            <li>
                                <strong>BUSY</strong>
                                <div>{TechStatusData ? `${TechStatusData.Busy}` : '(0)'}</div>
                            </li>
                            <li>
                                <strong>FREE</strong>
                                <div>{TechStatusData ? `${TechStatusData.Free}` : '(0)'}</div>
                                {/* <strong>
                                    <a href="javascript:;" onClick={() => this.setState({ showModal: true })}>
                                        {TechStatusData ? `${TechStatusData.Free}` : '(0)'}
                                    </a>
                                </strong> */}
                            </li>
                            <li>
                                <strong>ON BREAK</strong>
                                <div>{TechStatusData ? `${TechStatusData.OnBreak}` : '(0)'}</div>
                            </li>
                        </ul>
                    </div>
                </Panel>

                <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })} bsSize="large">
                    <Modal.Header closeButton>
                        <Modal.Title><strong>Modal Popup heading</strong></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>Content Heading</h4>
                        <p>Modal Content</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-default" onClick={() => this.setState({ showModal: false })}>Close</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default TicketsTechniciansPanel;



// WEBPACK FOOTER //
// ./app/tickets/components/TicketsTechniciansPanel.jsx